import { Attribute, Button, Column, Header, Row, ScrollContainer, Section, useLoading } from "best-common-react";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { getDayOfRequest } from "../../../api/RequesTixApi";
import AdminTicketsRevokeModal from "../../../components/todaysTickets/admin/AdminTicketsRevokeModal";
import TodaysTicketsGame from "../../../components/todaysTickets/TodaysTicketsGame";
import { DayOfGameRequestDTO } from "../../../types/TodaysTickets";
import { formatSubmittedDate } from "../../../util/TimeUtil";

type AdminTodaysTicketsEditRouteParams = {
  requestId: string;
};

const winningStatusIds = [1, 5];

const AdminTodaysTicketsEdit = () => {
  const { setLoading } = useLoading();
  const { requestId } = useParams<AdminTodaysTicketsEditRouteParams>();
  const [revokeOpen, setRevokeOpen] = useState<boolean>(false);
  const [request, setRequest] = useState<DayOfGameRequestDTO | undefined>(undefined);

  const getDayOfRequestCall = async (requestId: string) => {
    try {
      setLoading(true);
      const result: DayOfGameRequestDTO = await getDayOfRequest(requestId);
      setRequest(result);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!!requestId) {
      getDayOfRequestCall(requestId);
    }
  }, [requestId]);

  return (
    <div>
      <Header sticky title="Today's Tickets Request" />
      <ScrollContainer className="bcr-p-2">
        {!!request && (
          <div className="d-flex flex-column">
            <AdminTicketsRevokeModal
              isOpen={revokeOpen}
              onClose={() => setRevokeOpen(false)}
              requestId={request.dayOfRequestId}
            />
            <Section sectionKey="game-details" header="Game" showToggle={false}>
              <Row>
                <Column width={2}>
                  <TodaysTicketsGame
                    game={{
                      gamePk: request.game.gamePk,
                      home: request.game.teams.home.team,
                      away: request.game.teams.away.team,
                      gameDate: request.game.gameDate,
                      venue: request.game.venue,
                      ticketsLeft: undefined,
                      isLotto: false,
                      canRequestTickets: true,
                      hasBeenRequested: false,
                    }}
                  />
                </Column>
                {winningStatusIds.includes(request.statusId) && (
                  <Column width={2}>
                    <Button variant="default" onClick={() => setRevokeOpen(true)}>
                      Revoke Tickets
                    </Button>
                  </Column>
                )}
              </Row>
            </Section>
            <Section className="bcr-mt-2" sectionKey="request-details" header="Request Details" showToggle={false}>
              <Row>
                <Column width={3}>
                  <Attribute header="Requester" value={`${request.user.firstName} ${request.user.lastName}`} />
                </Column>
                <Column width={3}>
                  <Attribute header="Email" value={request.emailAddress} />
                </Column>
                <Column width={3}>
                  <Attribute header="Number of Tickets" value={request.numberOfTickets?.toString()} />
                </Column>
                <Column width={3}>
                  <Attribute header="Tickets Sent" value={request.ticketSentDisplay} />
                </Column>
                <Column width={3}>
                  <Attribute header="Requested Date" value={formatSubmittedDate(request.requestedDate)} />
                </Column>
                <Column width={3}>
                  <Attribute header="Status" value={request.status} />
                </Column>
              </Row>
            </Section>
          </div>
        )}
      </ScrollContainer>
    </div>
  );
};

export default AdminTodaysTicketsEdit;
